import React from 'react';
import { Header, Responsive, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import CourseEnrollment from './CourseEnrollment/CourseEnrollment';
import SemesterEnrollment from './SemesterEnrollment/SemesterEnrollment';
import Grades from './Grades/Grades';
import GradYearEnrollment from "./SemesterEnrollment/GradYearEnrollment";


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class ThirdCycle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchStudentOptions = this.fetchStudentOptions.bind(this);
    }

    componentDidMount() {
        this.fetchStudentOptions();
    }
    fetchStudentOptions() {
        axios.get('/students/third-cycle/')
            .then(res => {
                this.setState({
                    studentOptions: res.data.map(el => ({
                        ...el,
                        key: el.id,
                        value: { ...el },
                        text: el.firstName + ' ' + el.lastName + ' | ' + el.index,
                        description: el.studyProgramName ? el.studyProgramName : ''
                    }))
                });
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        const panes = [
            {
                menuItem: 'Upis u semestar',
                render: () => (<Tab.Pane as={Responsive}>
                    <SemesterEnrollment thisrdCycle fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Upis u apsolventski staž',
                render: () => (<Tab.Pane as={Responsive}>
                    <GradYearEnrollment specialist fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Upis na predmet',
                render: () => (<Tab.Pane as={Responsive}>
                    <CourseEnrollment thisrdCycle fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Unos ocjene',
                render: () => (<Tab.Pane as={Responsive}>
                    <Grades thisrdCycle fetchStudentOptions={this.fetchStudentOptions} studentOptions={this.state.studentOptions} />
                </Tab.Pane>)
            }
        ];
        return (
            <div>
                <h1>Treći ciklus</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Unos podataka
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ThirdCycle/ThirdCycle.js